<template>
    <div></div>
</template>

<script>
export default {
    name: 'ssologin',
    data() {
        return {
            callbackurl: '',
        };
    },
    created() {
        /** 获取callback地址 */
        if (Object.keys(this.$route.query).length > 0 && Object.prototype.hasOwnProperty.call(this.$route.query, 'callback')) {
            this.callbackurl = decodeURIComponent(this.$route.query.callback);
        }
        if (this.$cookies.isKey('token_chinagp')) {
            this.checkToken();
        } else {
            if (this.callbackurl.indexOf('?') > -1) {
                window.location.href = this.callbackurl + '&token=false';
            } else {
                window.location.href = this.callbackurl + '?token=false';
            }
        }
    },
    methods: {
        checkToken() {
            try {
                var _tokenkey = this.$cookies.get('token_chinagp');
                if (typeof(_tokenkey) != 'string') {
                    window.location.href = this.callbackurl + '&token=false';
                    return;
                }
                this.httphelper
                    .post('/api/LoginApi/CheckToken', {
                        tokenKey: _tokenkey,
                    })
                    .then(res => {
                        if (res.data.code == 200) {
                            var _tokenkey = this.$cookies.get('token_chinagp');
                            if (this.callbackurl.indexOf('?') > -1) {
                                window.location.href = this.callbackurl + '&token=' + _tokenkey;
                            } else {
                                window.location.href = this.callbackurl + '?token=' + _tokenkey;
                            }
                        } else {
                            if (this.callbackurl.indexOf('?') > -1) {
                                window.location.href = this.callbackurl + '&token=false';
                            } else {
                                window.location.href = this.callbackurl + '?token=false';
                            }
                        }
                    });
            } catch (e) {
                window.location.href = this.callbackurl + '&token=false';
            }
        },
    },
};
</script>
